// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left {
  width: 100%;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  cursor: auto;
  gap: .2vw;
  margin-top: 0.8px;
}

.middle {
  /* border: .05vw solid rgb(207, 255, 192) !important; */
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  /* padding: 0px !important; */
  padding-right: 0px !important;
  /* gap: 20px; */
}

.long-content-new {
  display: flex;
  align-items: center;
  justify-content: center;
}

.long-content-new-0 {
  display: flex;
  align-items: center;
  justify-items: center;
  margin-top: -0.20vw;
}

.long-content-typo {
  display: flex;
  align-items: center;
  font-family: "karla" !important;
  font-size: .7vw !important;
  font-weight: 400 !important;
  /* line-height: 1.2vw !important ; */
}

.long-content-typo-0 {
  display: flex;
  align-items: center;
  font-family: karla !important;
  font-size: .9vw !important;
  font-weight: 500;
  /* line-height: 1.5vw !important; */
}

.long-card-image {
  height: 8.5vw !important;
  width: 8.5vw !important;
  border-radius: .2vw !important;
  cursor: pointer !important;
}

.card-content {
  border-radius: 0.31vw;
  border: 0.03vw solid #cccccc !important;
  display: flex;
  gap: 0.63vw;
  padding: 1.11vh 0.63vw;
}

/* 
.filter-select {
  border:0.5px solid #262626;
  background-color: black;
  border-radius: 5px;
  display: flex;  
  width: fit-content;
}

.filter-select label {
  padding:0px 3.6px ; 
  height: 20px;
  margin-top: -3px;

}

.filter-select select {
  background-color: transparent;
  color:white;
  border:none;
  border-left: 0.5px solid #262626;
  font-family: "Karla";
  height: 20px;
  font-size: 10px;
  option {
    background-color: #262626;
  }
} */
.filter-select {
  border: 0.05vw solid #262626;
  background-color: black;
  border-radius: 0.3vw;
  display: flex;
  align-items: center;
  width: fit-content;
  height: 1.6vw;
  position: relative;
}

.filter-select label {
  padding: 0 0.3vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-select select {
  background-color: transparent;
  color: white;
  border: none;
  border-left: 0.05vw solid #262626;
  font-family: "Karla";
  font-size: 0.6vw;
  height: 100%;
  padding: 0 1.2vw 0 0.3vw;
  appearance: none;
}

.filter-select select option {
  background-color: #262626;
  color: white;
}

.filter-select .down-label {
  margin-top: 0.05vw;
  position: absolute;
  right: 0.3vw;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 0.5vw;
  color: white;
  transition: transform 0.3s ease;
}

.color-select {
  cursor: pointer;
}

.custom-select-value {
  display: inline-block;
  min-width: 3.7vw;
  max-width: 1vw;
  /* margin: 0px; */
  display: flex;
  align-items: center;
  padding: 0 1.2vw 0 0.3vw;
  height: 100%;
  font-family: "Karla";
  font-size: 0.6vw;
}

.custom-options {
  position: absolute;
  top: 100%;
  left: 1.1458vw;
  width: 78%;
  background: white;
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 0.3vw;
  overflow: hidden;
  z-index: 100;
}

.custom-options li {
  margin: 0.2604vw;
  padding: 0.4vw;
  color: black;
  cursor: pointer;
}

.custom-options li:hover {
  /* margin: 5px; */
  color: #fff;
  background: #000;
  border-radius: 0.4167vw;
  background: #444444;
}

.filter-select select::-webkit-scrollbar {
  display: none;
}

.custom-input::placeholder {
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/cards/longCard/longCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;EACvD,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;AACH;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".left {\n  width: 100%;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  cursor: auto;\n  gap: .2vw;\n  margin-top: 0.8px;\n}\n\n.middle {\n  /* border: .05vw solid rgb(207, 255, 192) !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n  /* padding: 0px !important; */\n  padding-right: 0px !important;\n  /* gap: 20px; */\n}\n\n.long-content-new {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.long-content-new-0 {\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  margin-top: -0.20vw;\n}\n\n.long-content-typo {\n  display: flex;\n  align-items: center;\n  font-family: \"karla\" !important;\n  font-size: .7vw !important;\n  font-weight: 400 !important;\n  /* line-height: 1.2vw !important ; */\n}\n\n.long-content-typo-0 {\n  display: flex;\n  align-items: center;\n  font-family: karla !important;\n  font-size: .9vw !important;\n  font-weight: 500;\n  /* line-height: 1.5vw !important; */\n}\n\n.long-card-image {\n  height: 8.5vw !important;\n  width: 8.5vw !important;\n  border-radius: .2vw !important;\n  cursor: pointer !important;\n}\n\n.card-content {\n  border-radius: 0.31vw;\n  border: 0.03vw solid #cccccc !important;\n  display: flex;\n  gap: 0.63vw;\n  padding: 1.11vh 0.63vw;\n}\n\n/* \n.filter-select {\n  border:0.5px solid #262626;\n  background-color: black;\n  border-radius: 5px;\n  display: flex;  \n  width: fit-content;\n}\n\n.filter-select label {\n  padding:0px 3.6px ; \n  height: 20px;\n  margin-top: -3px;\n\n}\n\n.filter-select select {\n  background-color: transparent;\n  color:white;\n  border:none;\n  border-left: 0.5px solid #262626;\n  font-family: \"Karla\";\n  height: 20px;\n  font-size: 10px;\n  option {\n    background-color: #262626;\n  }\n} */\n.filter-select {\n  border: 0.05vw solid #262626;\n  background-color: black;\n  border-radius: 0.3vw;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  height: 1.6vw;\n  position: relative;\n}\n\n.filter-select label {\n  padding: 0 0.3vw;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.filter-select select {\n  background-color: transparent;\n  color: white;\n  border: none;\n  border-left: 0.05vw solid #262626;\n  font-family: \"Karla\";\n  font-size: 0.6vw;\n  height: 100%;\n  padding: 0 1.2vw 0 0.3vw;\n  appearance: none;\n}\n\n.filter-select select option {\n  background-color: #262626;\n  color: white;\n}\n\n.filter-select .down-label {\n  margin-top: 0.05vw;\n  position: absolute;\n  right: 0.3vw;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 0.5vw;\n  color: white;\n  transition: transform 0.3s ease;\n}\n\n.color-select {\n  cursor: pointer;\n}\n\n.custom-select-value {\n  display: inline-block;\n  min-width: 3.7vw;\n  max-width: 1vw;\n  /* margin: 0px; */\n  display: flex;\n  align-items: center;\n  padding: 0 1.2vw 0 0.3vw;\n  height: 100%;\n  font-family: \"Karla\";\n  font-size: 0.6vw;\n}\n\n.custom-options {\n  position: absolute;\n  top: 100%;\n  left: 1.1458vw;\n  width: 78%;\n  background: white;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-radius: 0.3vw;\n  overflow: hidden;\n  z-index: 100;\n}\n\n.custom-options li {\n  margin: 0.2604vw;\n  padding: 0.4vw;\n  color: black;\n  cursor: pointer;\n}\n\n.custom-options li:hover {\n  /* margin: 5px; */\n  color: #fff;\n  background: #000;\n  border-radius: 0.4167vw;\n  background: #444444;\n}\n\n.filter-select select::-webkit-scrollbar {\n  display: none;\n}\n\n.custom-input::placeholder {\n  color: #333333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
